import moment from 'moment';
import { TOOLTIP_LABEL_FORMAT } from '@utils/constants';
import { get } from 'lodash';

const formatDate = ({ column, rowData }) => {
  const { dataKey } = column;
  return moment(rowData[dataKey]).format(TOOLTIP_LABEL_FORMAT);
};

const formatUsername = ({ rowData }) => {
  const { email = '', username = '' } = get(rowData, ['updatedBy', 'user']) || {};
  return email ? email : username;
};

const formatStatus = ({ rowData }) => {
  const { state } = rowData;
  return state ? state[0].toUpperCase() + state.slice(1) : 'Unknown';
};

const formatRecordForForm = (rowData) => ({
  scheduleId: rowData.id,
  triggerAt: rowData.triggerAt,
  activationState: rowData.triggerAt === null ? 'now' : 'schedule',
  notes: rowData.notes,
  policies: rowData.policyList.map((p) => get(p, ['policy', 'id'])),
  visible: true,
  state: rowData.state,
  emailIds: JSON.parse(rowData.emailIds),
});

export { formatDate, formatStatus, formatRecordForForm, formatUsername };
